export default __webpack_public_path__ + "static/media/ocdc-icon.5cf571a6.png";